module.exports = __webpack_public_path__ + "static/media/OpenedPosition.d61085df.PNG";